import { useState } from 'react';
import { apiClient } from 'config/api';
import useCustomerId from '../useCustomerId';

export interface AreaCreationBody {
  customerId: number;
  areaName: string;
  costCenter?: string;
}

/**
 * Custom hook to manage area creation.
 */
function useCreateArea() {
  const { customerId } = useCustomerId();
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Function to create an area.
   * @param customerId - Customer ID of the client where the area will be created.
   * @param areaName - Area name.
   * @param costCenter - Area's cost center.
   */
  const createArea = async ({ areaName, costCenter }: AreaCreationBody) => {
    setIsLoading(true);
    try {
      const { data } = await apiClient.post('/v2/partner/areas', {
        area_name: areaName,
        customer_id: customerId,
        cost_center: costCenter ? costCenter : null,
      });
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createArea,
  };
}

export default useCreateArea;
